'use client';

import {
  createContext,
  ReactNode,
  useContext,
  useState,
} from 'react';

export interface ContextValue {
  configs: Record<string, string>;
}

const AppContext = createContext({} as ContextValue);

export const useAppContext = () => useContext(AppContext);

export const AppContextProvider = ({ children }: { children: ReactNode }) => {
  const [configs] = useState<Record<string, string>>({});



  return (
    <AppContext.Provider
      value={{
        configs,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
